import BaseCrudRequests from "./BaseCrudRequests";

/**
 * Projects model
 *
 * @param {ApiHelper} api
 */
export default class ProjectsRequests extends BaseCrudRequests {
    baseUrl = '/projects';

    constructor(api) {
        super(api);
    }


    async validate(projectId, accessToken, errorHandler) {
        const url = this.baseUrl + '/' + projectId + '/a/' + accessToken;

        const response = await this.api.postRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async list(filter = {}, sorting =  null, status = null, errorHandler) {
        let url = this.baseUrl;
        let query = {};
        if (filter.searchText) {
            query.filter = filter.searchText;
        }
        if (filter.page) {
            query.page = filter.page;
        }
        if (filter.hasOwnProperty('archived') && filter.archived) {
            query.archived = true;
        }
        if (sorting) {
            query.sort = sorting.field;
            query.direction = sorting.direction;
        }
        if (status) {
            query.status = status;
        }
        if (Object.keys(query).length) {
            url += '?' + new URLSearchParams(query).toString();
        }

        const response = await this.api.getRequest(url);
        return this.processResponse(response, errorHandler);
    }


    async listAdmin(filter = {}, errorHandler) {
        let url = this.baseUrl+'/admin-list';
        for (let key in filter) {
            if (key === 'sorting') {
                url += (url.indexOf('?') === -1 ? '?' : '&') + 'sort=' + filter[key].field + '&direction=' + filter[key].direction;
                continue;
            }
            if (filter[key]) {
                url += (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + filter[key];
            }
        }

        const response = await this.api.getRequest(url);
        return this.processResponse(response, errorHandler);
    }


    async view(pk, errorHandler) {
        let url = this.baseUrl;
        if (typeof pk === 'object') {
            url += '/' + pk.pk;
            if (pk.access_token) {
                url += '?access_token=' + pk.access_token;
            }
        } else {
            url += '/' + pk;
        }

        const response = await this.api.getRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async updateWithAccessToken(accessToken, pk, data, errorHandler) {
        const url = this.baseUrl+'/' + pk + '/with-access-token/' + accessToken;

        const response = await this.api.postRequest(url, data);

        return this.processResponse(response, errorHandler);
    }


    async refreshUniversalAccessKey(pk, data, errorHandler) {
        let url = this.baseUrl + '/' + pk + '/refresh-ua';

        const response = await this.api.postRequest(url, data);

        return this.processResponse(response, errorHandler);
    }


    async getUniversalAccessKey(pk, errorHandler) {
        let url = this.baseUrl + '/' + pk + '/get-ua';

        const response = await this.api.getRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async requestReport(projectId, data, errorHandler) {
        const url = this.baseUrl + '/' + projectId + '/request-report';

        const response = await this.api.postRequest(url, data);

        return this.processResponse(response, errorHandler);
    }


    async copy(pk, errorHandler) {
        let url = this.baseUrl;
        if (typeof pk === 'object') {
            url += '/' + pk.pk + '/copy';
            if (pk.access_token) {
                url += '?access_token=' + pk.access_token;
            }
        } else {
            url += '/' + pk + '/copy';
        }

        const response = await this.api.postRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async deleteShape(projectId, shapeId, errorHandler) {
        const url = this.baseUrl+'/' + projectId + '/shapes/' + shapeId;

        const response = await this.api.deleteRequest(url);

        return this.processResponse(response, errorHandler);
    }
}